const getters = {
  token: state => state.user.token,
  // 头像
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  cartnum: state => state.user.cartnum,
  rank: state => state.user.rank,
  status: state => state.user.status
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js